module.exports = __webpack_public_path__ + "img/salvador.5b14da72.png";